module.exports = __webpack_public_path__ + "img/ai-quiz-generator-hover.78852a0f.png";